module.exports = __webpack_public_path__ + "static/media/F15-128659-Consilient-Mysimba-GP-Consult-Forum-Obesity.07da1b81.gif";